import { type FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { Link, LinkButton } from "~/common/components/Link";
import { PopperTooltip } from "../../../common/components/Tooltip";
import { URL_PREFERRED_PRODUCTS } from "~/utils/url/staticUrls";

interface DesignationProps {
  marketDesignation: string;
  tooltipSide?: "left" | "right" | "bottom";
  as?: keyof JSX.IntrinsicElements;
}

const ProductMMD: FC<DesignationProps> = (props) => {
  const { t } = useTranslation();
  const { marketDesignation, as = "span", tooltipSide = "bottom-start" } = props;

  const Cmp = as;

  return (
    <PopperTooltip
      placement={tooltipSide}
      contentClassName="scha__product_mmd_tooltip"
      innerClassName="scha__product_mmd_tooltip_inner"
      tooltipContent={
        <div className="scha__product_mmd_tooltip-content">
          <span>{t("product.mmd.tooltip.content")}</span>
          <LinkButton className="mt-3">
            <Link href={URL_PREFERRED_PRODUCTS}>
              {" "}
              {/** Todo: link to be updated  */}
              {t("product.mmd.tooltip.readmore")}
            </Link>
          </LinkButton>
        </div>
      }
    >
      <Cmp className={"scha__product-mmd"} data-test-id={"product-mmd"}>
        {marketDesignation}
      </Cmp>
    </PopperTooltip>
  );
};

export default memo(ProductMMD);
